module.exports = __webpack_public_path__ + "img/saoma.3a19896e.png";